import { configureStore } from "@reduxjs/toolkit";
import { showFormSlice } from "./reducers/showFormSlice";

const store = configureStore({
  reducer: {
    showForm: showFormSlice.reducer,
  },
});

export { store };
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
